<template>
	<div class='main-mybody' style="padding-top: 1rem;" id='homejiaban'>
		<a-row>
			<a-col :span='11'>
				<div>
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="inline" :rules='rules' hideRequiredMark style="width:100%">
						<div class='look_g'>
							<div></div>加班時間
						</div>
						<div class='jinmargin'>
							<div style="display:flex;">
								<div slot="label" v-html='"日&emsp;期："' style="display: flex;color: #000000;font-size: 0.75rem;align-items: center;flex-shrink: 0;"></div>
								<a-date-picker v-model="value1" @change="dateClick(1)" placeholder='' style="width:100%"/>
							</div>
							<div style="display:flex;margin-top: 20px;">
								<div slot="label" v-html='"時&emsp;間："' style="display: flex;color: #000000;font-size: 0.75rem;align-items: center;flex-shrink: 0;"></div>
								<div style="display: flex;align-items: center;">
									<a-input placeholder='' v-model="form.begintime1" class='warp_widths'
										:maxLength='2' @blur="inputnum('begintime1','s')" />
									<div style="display: inline-block;margin: .2rem;">:</div>
									<a-input placeholder='' v-model="form.begintime2" class='warp_widths'
										:maxLength='2' @blur="inputnum('begintime2')" />
									<div style="display: inline-block;margin: 0 .6rem;">一</div>
									<a-input placeholder='' v-model="form.endtime1" class='warp_widths'
										:maxLength='2' @blur="inputnum('endtime1','s')" />
									<div style="display: inline-block;margin: .2rem;">:</div>
									<a-input placeholder='' v-model="form.endtime2" class='warp_widths'
										:maxLength='2' @blur="inputnum('endtime2')" />
								</div>
							</div>
						</div>						
						<div class='main-wid' style="width:100%;margin-top: 20px;"></div>
						<div class='look_g'>
							<div></div>加班匯總
						</div>		
						<div>
							<div style="display: flex;font-size: 0.75rem;color: #000000;">
								<div slot="label" v-html='"開始時間："' style="display: inline-block;"></div>
								<div v-if="form.begintime2">{{value1}} {{form.begintime1}}:{{form.begintime2}}</div>
								<!-- <div v-else>{{value1}} {{form.begintime1}}:00</div> -->
							</div>
							<div style="display: flex;margin-top: 20px;font-size: 0.75rem;color: #000000;">
								<div slot="label" v-html='"結束時間："' style="display: inline-block;"></div>
								<div v-if="form.endtime2">{{value1}} {{form.endtime1}}:{{form.endtime2}}</div>
							</div>
							<div style="display: flex;margin-top: 20px;margin-bottom: 1rem; font-size: 0.75rem;color: #000000;">
								<div slot="label" v-html='"加班時數："' style="display: inline-block;"></div>
								<div>{{this.form.str1}}</div>
							</div>
						</div>
					
					</a-form-model>
				</div>
			</a-col>
			<a-col :span='2'></a-col>
			<a-col :span='11'>
				<div class='look_g'>
					<div></div>補假時間
				</div>
				<div style="display:flex;">
					<div slot="label" v-html='"日&emsp;期："' style="display: flex;color: #000000;font-size: 0.75rem;align-items: center;flex-shrink: 0;"></div>
					<a-date-picker v-model="value2" @change="dateClick(2)" placeholder='' style="width:100%"/>
				</div>
				<!-- <div class='jinmargin' style="margin-bottom: .3rem;">
					<a-form-model-item>
						<div slot="label" v-html='"補假日期"'
							style="display: inline-block;color: #000000;"></div>
						<div style="display: inline-block;">
							<a-input placeholder='請輸入年' v-model="form.bjdate1" class='warp_width'
								@blur="yearfn('bjdate1')" style=' width: 5.5rem;' :maxLength='4' />
							<div style="display: inline-block;margin: 0 .8rem;">年</div>
							<a-input placeholder='請輸入月' v-model="form.bjdate2" class='warp_width'
								@blur="yearfn('bjdate2','y')" style=' width: 5.5rem;' :maxLength='2' />
							<div style="display: inline-block;margin: 0 .8rem;">月</div>
							<a-input placeholder='請輸入日' v-model="form.bjdate3" class='warp_width'
								@blur="yearfn('bjdate3','d')" style=' width: 5.5rem;' :maxLength='2' />
							<div style="display: inline-block;margin-left: .8rem;">日</div>
						</div>
					</a-form-model-item>
				</div> -->
				<div class='jinmargin'>
					<div style="display:flex;margin-top: 20px;">
						<div slot="label" v-html='"時&emsp;間："' style="display: flex;color: #000000;font-size: 0.75rem;align-items: center;flex-shrink: 0;"></div>
						<div style="display: flex;align-items: center;">
							<a-input placeholder='' v-model="form.bjbegintime1" class='warp_widths'
								:maxLength='2' @blur="inputnum('bjbegintime1','s')" />
							<div style="display: inline-block;margin: .2rem;">:</div>
							<a-input placeholder='' v-model="form.bjbegintime2" class='warp_widths'
								:maxLength='2' @blur="inputnum('bjbegintime2')" />
							<div style="display: inline-block;margin: 0 .6rem;">一</div>
							<a-input placeholder='' v-model="form.bjendtime1" class='warp_widths'
								:maxLength='2' @blur="inputnum('bjendtime1','s')" />
							<div style="display: inline-block;margin: .2rem;">:</div>
							<a-input placeholder='' v-model="form.bjendtime2" class='warp_widths'
								:maxLength='2' @blur="inputnum('bjendtime2')" />
						</div>
					</div>
				</div>	
				<div class='main-wid' style="width:100%;margin-top: 20px;"></div>	
				<div class='look_g'>
					<div></div>補假匯總
				</div>	
				<div>
					<div style="display: flex;font-size: 0.75rem;color: #000000;">
						<div slot="label" v-html='"開始時間："' style="display: inline-block;"></div>
						<div v-if="form.bjbegintime2">{{value2}} {{form.bjbegintime1}}:{{form.bjbegintime2}}</div>
						<!-- <div v-else>{{value1}} {{form.begintime1}}:00</div> -->
					</div>
					<div style="display: flex;margin-top: 20px;font-size: 0.75rem;color: #000000;">
						<div slot="label" v-html='"結束時間："' style="display: inline-block;"></div>
						<div v-if="form.bjendtime2">{{value2}} {{form.bjendtime1}}:{{form.bjendtime2}}</div>
					</div>
					<div style="display: flex;margin-top: 20px;margin-bottom: 1rem;font-size: 0.75rem;color: #000000;">
						<div slot="label" v-html='"補假時數："' style="display: inline-block;"></div>
						<div>{{this.form.str2}}</div>
					</div>
				</div>			
				<!-- <div class='jinmargin'>
					<a-form-model-item>
						<div slot="label" v-html='"補假時數"' style="display: inline-block;color: #000000;">
						</div>
						<div style="display: inline-block;">{{form.str2}}</div>
					</a-form-model-item>
				</div> -->
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import App from '@/assets/app.js';

	export default {
		props: ['applyid', 'pared'],
	
		data() {
			return {
				fourthqty: '',
				value1:'',
				value2:'',
				formview: {
					createtime: "",
					department: "",
					position: "",
					realname: "",
					job: '',
					sex: 0,
				},
				visible: true,
				ishand: false,
				rules: {},
				form: {
					"type": 3, //類型 1 假期申請 2 外出 3加班
					"jbtype": 1, // 1 加班費 2 補假
					"jbdate": "", //加班日期
					"begintime:": "", //加班開始
					begintime1: '',
					begintime2: '',
					"endtime": "", //加班截止
					endtime1: '',
					endtime2: '',
					"bjdate": "", // 補假日期
					bjdate1: '',
					bjdate2: '',
					bjdate3: '',
					"bjbegintime": "", //補假開始
					bjbegintime1: '',
					bjbegintime2: '',
					"bjendtime": "", //補假截止
					bjendtime1: '',
					bjendtime2: '',
					issave: '', //issave 提交 2 儲存 1
					num1: [],
					num2: []
				},
				yeararr: [{
					text: '加班費',
					value: '1',
				}, {
					text: '補假',
					value: '2',
				}],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
				],
			}
		},
		created() {
			let _this = this;
			_this.handimg()
		},
		mounted() {

		},
		methods: {
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || '',
						token: this.$store.state.token,
						applytype:2
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						this.value1 = res.data.jbdate;
						this.value2 = res.data.bjdate;
						if (this.pared.applyid) {
							let arr = {}
							arr = res.data
							arr.endtime1 = ''
							arr.endtime2 = ''
							arr.begintime1 = ''
							arr.begintime2 = ''
							arr.bjdate1 = ''
							arr.bjdate2 = ''
							arr.bjdate3 = ''
							arr.bjbegintime1 = ''
							arr.bjbegintime2 = ''
							arr.bjendtime1 = ''
							arr.bjendtime2 = ''
							// arr.jbdate = arr.jbdate.split('-')[2]+'-'+arr.jbdate.split('-')[1]+'-'+arr.jbdate.split('-')[0]
							if (arr.endtime) {
								arr.endtime1 = arr.endtime.split(':')[0]
								arr.endtime2 = arr.endtime.split(':')[1]
							}

							if (arr.begintime) {
								arr.begintime1 = arr.begintime.split(':')[0]
								arr.begintime2 = arr.begintime.split(':')[1]
							}
							// if (arr.bjdate) {
							// 	arr.bjdate1 = arr.bjdate.split('-')[0]
							// 	arr.bjdate2 = arr.bjdate.split('-')[1]
							// 	arr.bjdate3 = arr.bjdate.split('-')[2]
							// }
							if (arr.bjbegintime) {
								arr.bjbegintime1 = arr.bjbegintime.split(':')[0]
								arr.bjbegintime2 = arr.bjbegintime.split(':')[1]
							}
							if (arr.bjendtime) {
								arr.bjendtime1 = arr.bjendtime.split(':')[0]
								arr.bjendtime2 = arr.bjendtime.split(':')[1]
							}
							arr.num1 = []
							arr.num2 = []
							this.form = {}
							this.form = arr
							this.backdate()
							// if(this.form.jbtype == 2){ 

							// }
						}
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			backdate() {
				let num1, num2, b1, b2;
				// num1 = (this.form.endtime1 * 1 >= this.form.begintime1 * 1) ? (this.form.endtime1 * 1 - this.form.begintime1 * 1) : ((this.form.endtime2 * 1 + 24) - this.form.begintime2 * 1)
				num1 = (this.form.endtime1 * 1 >= this.form.begintime1 * 1) ? (this.form.endtime1 * 1 - this.form.begintime1 * 1) : 0
				num2 = (this.form.endtime2 * 1 >= this.form.begintime2 * 1) ? (this.form.endtime2 * 1 - this.form.begintime2 * 1) : ((this.form.endtime2 * 1 + 60) - this.form.begintime2 * 1)
				// b1 = (this.form.bjendtime1 * 1 >= this.form.bjbegintime1 * 1) ? (this.form.bjendtime1 * 1 - this.form.bjbegintime1 * 1) : (this.form.bjendtime1 * 1 - this.form.bjbegintime1 * 1 + 24)
				b1 = (this.form.bjendtime1 * 1 >= this.form.bjbegintime1 * 1) ? (this.form.bjendtime1 * 1 - this.form.bjbegintime1 * 1) : 0
				b2 = (this.form.bjendtime2 * 1 >= this.form.bjbegintime2 * 1) ? (this.form.bjendtime2 * 1 - this.form
					.bjbegintime2 * 1) : (this.form.bjendtime2 * 1 - this.form.bjbegintime2 * 1 + 60)
				if (this.form.endtime1 && this.form.endtime2 && this.form.begintime1 && this.form.begintime2) {
					if ((num1 >= 0 && num2 > 0) || (num1 > 0 && num2 >= 0)) {
						this.form.num1 = [num1, num2]
						this.$set(this.form, 'str1', num1 + '時' + num2 + '分')
						// this.form.str1 = num1 + '時' + num2 + '分'
					}else{
						this.$set(this.form, 'str1', '')
					}
				}
				console.log( num1, num2);
				if (this.form.bjendtime1 && this.form.bjendtime2 && this.form.bjbegintime1 && this.form.bjbegintime2) {
					if ((b1 >= 0 && b2 > 0) || (b1 > 0 && b2 >= 0)) {
						this.form.num2 = [b1, b2]
						this.$set(this.form, 'str2', b1 + '時' + b2 + '分')
						// this.form.str2 = b1 + '時' + b2 + '分'
					}else{
						this.$set(this.form, 'str2', '')
	
					}
				}
			},
			// handff(val) {
			// 	this.form.jbdate = ''
			// 	if (val) {
			// 		this.form.jbdate = val
			// 	}
			// },
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			dateClick(val){
				if (val == 1) {
					this.value1 = App.oDate.secsTime3(this.value1._d);
					this.form.jbdate = this.value1;
				}else{
					this.value2 = App.oDate.secsTime3(this.value2._d);
					this.form.bjdate = this.value2;
				}
				console.log(this.form.jbdate,this.form.bjdate);
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			yearfn(val, sta) {
				if (isNaN(Number(this.form[val]))) {
					let obj  = JSON.parse(JSON.stringify(this.form))
					this.$set(obj , val , '')
					this.form = obj
				} else {
					if (this.form[val] == ''){
						return
					}
					// this.form[val] = (Number(this.form[val])).toFixed(0)
					if (sta == 'y') {
						if (this.form[val] > 12) {
							this.form[val] = ''
						}
					}
					if (sta == 'd') {
						if (this.form[val] > 31) {
							this.form[val] = ''
						}
					}
					// if (0 <= this.form[val] && this.form[val] < 10&&sta) {
					// 	this.form[val] = '0' + this.form[val]
					// }
				}
				console.log(this.form)
			},
			inputnum(val, sta) {
				if (isNaN(Number(this.form[val]))) {
					let obj  = JSON.parse(JSON.stringify(this.form))
					this.$set(obj , val , '')
					this.form = obj
				} else {
					if (this.form[val] == '') {
						return
					}
					this.form[val] = (Number(this.form[val])).toFixed(0)
					if (0 <= this.form[val] && this.form[val] < 10) {
						this.form[val] = '0' + this.form[val]
					}
					if (sta == 's') {
						if (this.form[val] > 24) {
							this.form[val] = ''
						}
					} else {
						if (this.form[val] > 60) {
							this.form[val] = ''
						}
					}
				}
				this.backdate()
			},
			resetForm(val) {
				
				if (!this.form.jbdate) {
					App.oTool.warningT('請選擇加班費日期');
					return
				}
				// if (!this.form.jbtype) {
				// 	App.oTool.warningT('請選擇加班費還是補假');
				// 	return
				// }
				// if(this.form.jbtype == 1){//加班費
				console.log(this.form)
				if ((this.form.begintime1 && this.form.begintime2 && this.form.endtime1 && this.form.endtime2)&&
				(this.form.bjendtime1&&this.form.bjendtime2&&this.form.bjbegintime1&&this.form.bjbegintime2)) {
					this.form.begintime = this.form.begintime1 + ':' + this.form.begintime2
					this.form.endtime = this.form.endtime1 + ':' + this.form.endtime2
					this.form.jbtype = 2
				} else if ((this.form.begintime1 && this.form.begintime2 && this.form.endtime1 && this.form.endtime2)&&
				(''==this.form.bjendtime1&&''==this.form.bjendtime2&&''==this.form.bjbegintime1&&''==this.form.bjbegintime2)) {
					this.form.begintime = this.form.begintime1 + ':' + this.form.begintime2
					this.form.endtime = this.form.endtime1 + ':' + this.form.endtime2
					this.form.jbtype = 1
					
				} else {
					App.oTool.warningT('請填完整的加班申請');
					//請填寫具體加班時間
					return
				}
				// }
				if (this.form.jbtype == 2) { //補假
					if (this.form.bjdate &&
						this.form.bjbegintime1 && this.form.bjbegintime2 && this.form.bjendtime1 && this.form.bjendtime2) {
						this.form.bjbegintime = this.form.bjbegintime1 + ':' + this.form.bjbegintime2
						this.form.bjendtime = this.form.bjendtime1 + ':' + this.form.bjendtime2
					} else {
						// App.oTool.warningT('請填寫具體補假時間');
						// return
					}
					// bjdate jbdate			
					//補假時間  能小于等于加班时间
					if (this.form.num1.length > 0 && this.form.num2.length > 0) {
						if ((this.form.num1[0] < this.form.num2[0])) {
							
							App.oTool.warningT('補假時間小于等于加班时间');
							return
						}else if((this.form.num1[0] == this.form.num2[0])){
							if ((this.form.num1[1] < this.form.num2[1])) {
								App.oTool.warningT('補假時間小于等于加班时间');
								return
							}
						}
					}
				}

				let begin = this.form.begintime.split(':'),
				end = this.form.endtime.split(':');
				if((end[0]*1>begin[0]*1)||(end[0]*1==begin[0]*1&&end[1]*1>begin[1]*1)){
					// ||(end[0]*1>begin[0]*1&&end[1]*1>=begin[1]*1)
				}else{
					App.oTool.warningT('加班時間不正確');
					return 
				}
				// 123123
				if (this.value2 || this.form.bjbegintime || this.form.bjendtime) {
					if (!this.value2) {
						App.oTool.warningT('請填完整的補假申請');
						return
					}
					if (!this.form.bjbegintime) {
						App.oTool.warningT('請填完整的補假申請');
						return
					}
					if (!this.form.bjendtime) {
						App.oTool.warningT('請填完整的補假申請');
						return
					}
					let begin_bj = this.form.bjbegintime.split(':'),
					end_bj = this.form.bjendtime.split(':');
					if((end_bj[0]*1>begin_bj[0]*1)||(end_bj[0]*1==begin_bj[0]*1&&end_bj[1]*1>begin_bj[1]*1)){
						// ||(end[0]*1>begin[0]*1&&end[1]*1>=begin[1]*1)
					}else{
						App.oTool.warningT('補假時間不正確');
						return 
					}
					console.log(this.form,begin_bj);
				}

				let jbtime1 = this.form.jbdate + this.form.begintime
				let jbtime2 = this.form.jbdate + this.form.endtime
				let bjtime1 = this.form.bjdate + this.form.bjbegintime
				let bjtime2 = this.form.bjdate + this.form.bjendtime
				console.log(jbtime1,jbtime2,bjtime1,bjtime2 );
				if (jbtime1 == bjtime1 && jbtime2 == bjtime2) {
					App.oTool.warningT('申請日期和時間不能相同');
					return
				}
				// let jbtime = this.form.
				// if (condition) {
					
				// }
				// if (this.form.endtime == '24:00') {
				// 	this.form.endtime = '00:00'
				// }
				// if (this.form.bjendtime == '24:00') {
				// 	this.form.bjendtime = '00:00'
				// }
				console.log(this.form.bjendtime);
				this.form.issave = val
				this.form.token = this.$store.state.token;
				this.form.asktype = "1"
				this.form.type = 3
				// this.$refs[formName].resetFields();
				this.$ajax({
					method: 'post',
					url: this.$api.newApply,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#homejiaban {
		.ant-input:focus {
			border: none;
			border-bottom: 1px solid #d9d9d9;
			box-shadow: none;
		}
		.warp_widths {
			border: none;
			border-radius: 0;
			border-bottom: 1px solid #d9d9d9;
		}

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 7rem;
		}

		.titName {
			font-size: .75rem !important;
			color: #000;
		}

		.comname {
			font-size: .75rem !important;
		}

		.ant-modal {
			top: 6vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: .75rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .6rem;
		}
		.jinmargin{
			.ant-form-item {
				margin-bottom: 0rem;
				margin-top: 0.2rem;
			}
			.ant-col{
				margin: 0;
			}
		}
		.ant-form-item label {
			font-size: .75rem !important;
			width: 4rem;
		}

		.ant-input {
			font-size: .75rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .75rem !important;
		}

		.ant-form-item-children {
			font-size: .75rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}



		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}



		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
